///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Modal from "../../Modal";
import messages from "../../../helpers/messages";
import ChevronRight from "../../icons/ChevronRight";
import HelpIcon from "../../icons/HelpIcon";
import SpinnerButton from "../banner/SpinnerButton";
import SystemErrorModal from "../../SystemErrorModal";

export const FinalSubmissionModal = ({
  open,
  handleClose,
  handleSendSubmissions,
  submitCapacityMatchIsLoading,
  submitCapacityMatchFailure
}) => {
  return (
    <>
      <SystemErrorModal
        open={open && submitCapacityMatchFailure}
        large
        closeModal={handleClose}
        handleExit={handleClose}
        handleTryAgain={handleSendSubmissions}
      />
      <Modal
        title={messages.finalSubmission.defaultMessage}
        open={open && !submitCapacityMatchFailure}
        large={true}
        handleClose={handleClose}
        titleClass="modal__title_light uppercase"
        bodyClass="border-top-grey px-24 pt-24"
        closeButtonClass="modal__close-button mr-16 mt-16"
        modalStyle={{ width: 470 }}
      >
        <p className="text-center m-0">
          <HelpIcon height={40} width={40} />
        </p>
        <p
          data-testid="warning-message"
          className="delta-heading text-center text-black pb-4"
        >
          {messages.areYouSureYouAreReadyToSumbit.defaultMessage}
        </p>
        <p
          data-testid="confirmation-message"
          className="font-size-14 text-center text-grayish-blue m-0 pb-8 px-20"
        >
          {messages.finalSubmissionConfirmationMessage.defaultMessage}
        </p>

        <div className="grid fr my-24">
          <div className="grid__cell pl-8">
            {submitCapacityMatchIsLoading ? (
              <SpinnerButton minWidth="150px" />
            ) : (
              <button
                data-testid="send-submissions"
                className="text-button one-whole cursor-pointer text-transform-none short-button"
                onClick={handleSendSubmissions}
                style={{ minWidth: 150 }}
              >
                {messages.sendSubmissions.defaultMessage}
                <ChevronRight
                  className="align-text-bottom ml-8"
                  fill="#0066FA"
                />
              </button>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FinalSubmissionModal;
